import { useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { getConfig } from 'config';
import { Context } from './Store';

import { useDriverSession, requiresLogin } from './auth/DriverSession';
import types from './Reducer/types';
import { useNavigate } from 'react-router-dom';


export default () => {
  let navigate = useNavigate();
  const { getAccessToken } = useDriverSession();
  const { apiOrigin = 'http://localhost:3001' } = getConfig();
  const api = useRef(
    axios.create({
      baseURL: `${apiOrigin}/api/`,
    }),
  );
  const { state, dispatch } = useContext(Context);
  const unknownUser = useRef(false);

  const goToUnknownUserError = () => {
    navigate('/unknown-user');
  }

  useEffect(() => {
    const currentAPI = api.current;
    const requestInterceptorId = currentAPI.interceptors.request.use(async (config) => {
      let token;
      try {
        token = await getAccessToken();
      } catch (err) {
        if (requiresLogin(err)) {
          // The session boundary hides protected pages and owns the redirect.
          // Cancel rather than sending an unauthenticated API request.
          throw new axios.Cancel('Re-authenticating');
        }
        throw err;
      }
      const accessToken = token?.access_token || token;
      config.headers.authorization = `Bearer ${accessToken}`;
      config.cancelToken = axios.CancelToken.source().token;
      if (state.apiToken === accessToken && !unknownUser.current) {
        return config;
      }
      try {
        dispatch({
          type: types.SET_API_TOKEN,
          payload: accessToken,
        });
        await axios.get(`${apiOrigin}/api/status`, {
          headers: {
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        });
        unknownUser.current = false;
      } catch (e) {
        console.log(e);
        unknownUser.current = true;
        goToUnknownUserError();
      }
      return config;
    });
    return () => {
      currentAPI.interceptors.request.eject(requestInterceptorId);
    };
  });
  return api.current;
};
